import {Logger, Category} from '@simpleinvest/front-end-logger';
// eslint-disable-next-line import/no-cycle
import overviewService from '@client/services/overview';
import Activity from '@client/models/store/activity';
// eslint-disable-next-line import/no-cycle
import transfersService from '@client/services/transfers';

const logger = new Logger({
  category: Category.Activity,
  fileName: 'activity.js',
});

const stateObj = function () {
  return new Activity();
};

const actions = {
  async getAccountActivity({commit}, {userId}) {
    try {
      const response = await overviewService.getAccountActivityForUserId(userId);

      commit('SET_CASH_FLOW_INFO', response.data.data.cashFlowInfo);
      commit('SET_ACCOUNT_ACTIVITY', response.data.data.activity);
      commit('SET_IS_ACCOUNT_ACTIVITY_LOADED', true);
    } catch (error) {
      commit('SET_ACCOUNT_ACTIVITY_ERROR_THROWN', true);
      commit('SET_IS_ACCOUNT_ACTIVITY_LOADED', false);

      logger.addBreadcrumb({
        callingFuncName: 'getAccountActivity',
        message: `getAccountActivity error caught`,
      });
      logger.logException({
        error,
        fingerprint: ['getAccountActivity'],
      });
    }
  },
  async getCompletedTransactions({rootState}, payload) {
    const payloadObj = payload;

    payloadObj.postData.clientId = rootState.user.id;
    const result = await transfersService.getCompletedTransactions(payloadObj);

    if (!result) {
      throw new Error('Failed to get transactions');
    }

    return result;
  },
};

const mutations = {
  SET_CASH_FLOW_INFO(state, cashFlowInfo) {
    state.cashFlowInfo = cashFlowInfo;
  },
  SET_ACCOUNT_ACTIVITY(state, accountActivity) {
    state.accountActivity = accountActivity;
  },
  SET_IS_ACCOUNT_ACTIVITY_LOADED(state, loaded) {
    state.accountActivityLoaded = loaded;
  },
  SET_ACCOUNT_ACTIVITY_ERROR_THROWN(state, payload) {
    state.accountActivityErrorThrown = payload;
  },
};

const gettersObj = {
  cashFlowInfo: (state) => state.cashFlowInfo,
  accountActivity: (state) => state.accountActivity,
  isAccountActivityLoaded: (state) => state.accountActivityLoaded,
  accountActivityErrorThrown: (state) => state.accountActivityErrorThrown,
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
  mutations,
  getters: gettersObj,
};
